"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/*tslint:disable no-any*/
function ArrayField(jsonProperty, type, optional, genericTypes) {
    if (optional === void 0) { optional = false; }
    if (genericTypes === void 0) { genericTypes = null; }
    return function (target, propertyKey, parameterIndex) {
        Reflect.defineMetadata("field:" + parameterIndex, { propName: jsonProperty, type: type, optional: optional }, target);
        if (genericTypes) {
            Object.keys(genericTypes.types).forEach(function (id) {
                Reflect.defineMetadata("generic:" + jsonProperty, genericTypes, target);
            });
        }
    };
}
exports.ArrayField = ArrayField;
/*tslint:enable no-any*/
